import useMarkdown from '@/hooks/useMarkdown';
import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';

function Content() {
  const marked = useMarkdown();

  const { t } = useTranslation('landing-page');
  const content = t('content');

  return (
    <Container
      data-cy="content"
      component="div"
      dangerouslySetInnerHTML={{
        __html: marked(content)
      }}
    />
  );
}

export default Content;
